module.exports = __webpack_public_path__ + "img/sy.fd4243a5.jpg";